riot.control = riot.observable()
riot.STATE = {}
riot.EVT = {
  updateInfobox: 'update_infobox',
  clearInfobox: 'clear_infobox',
  mapJumpTo: 'map_jump_to',
  setMarker: 'set_marker',
  clearMarker: 'clear_marker',
  clearResults: 'clear_results',
  resetMap: 'reset_map'
}



// WEBPACK FOOTER //
// ./src/scripts/riot_events.js